
import PreEntryApi from '../../assets/js/preentry'
import Validate from '../../assets/js/pre_validate'
import Uploader from './uploader'
import {i18nHelper} from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import LiAreaSelect from '../li_area_select'
import LiAreaHomeSelect from '../li_area_home_select'
import LiAreaCurrentSelect from '../li_area_current_select'
import LiAreaContactSelect from '../li_area_contact_select'
import LiAreaHuSelect from '../li_area_hu_select'
import $ from 'jquery'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Search from 'vux/src/components/search/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
components: {
XButton,
Flexbox,
FlexboxItem,
Group,
Cell,
XInput,
Search,
PopupRadio,
Loading,
Datetime,
Uploader,
Confirm,
XTextarea,
OnboardHeader,
LiAreaSelect,
LiAreaHuSelect,
LiAreaHomeSelect,
LiAreaCurrentSelect,
LiAreaContactSelect,
XHeader
},
data () {
return {
icTypeItems: [],
sexItems: [],
registeredTypeCNItems: [],
registeredTypeFNItems: [],
residenceTypeItems: [],
marriageItems: [],
politicalOutlookItems: [],
degreeTypeItems: [],
nationChangeItems: [],
emergencyItems: [],
nationItems: [],
isIntern: 0,
current_address: '',
isZH: true,
id: '',
name: '', // 中文姓名
sex: '1', // 性别
birthday: '', // 生日
mobile: '', // 手机号码
email: '', // 联系邮箱
ic_type: this.isZH ? 1 : 2, // 证件类型
surname_pinyin: '', // 姓全拼
surname_zh: '', // 姓
given_name_zh: '', // 名
name_pinyin: '', // 名全拼
ic_no: '', // 证件号码
ic_expired_date: '', // 证件有效期
certificates_long_effective: 1,
nation: '', // 名族
country_id: this.isZH ? 47206 : '', // 国籍ID 默认中国
/* country_no: '86', //国籍区号 */
country_name: this.isZH ? '中国' : '', // 证件类型
city_id: '', // 籍贯城市ID
city_name: '', // 籍贯城市名称
register_province_id: '', // 户籍所在地 省id
register_province_name: '', // 户籍所在地 省name
register_city_id: '', // 户籍所在地 市id
register_city_name: '', // 户籍所在地 市name
register_county_id: '', // 户籍所在地 县/区id
register_county_name: '', // 户籍所在地 县/区name
register_address: '', // 户籍所在地 详细地址
home_address: '', // 家庭住址
first_work_date: '', // 首次工作时间
registered_type: 1, // 户口类型
residence_type: 1, // 户口性质
residence_type_disable: true,
marriage: 1, // 婚育状况
political_status: '', // 政治面貌
has_friend: 2, // 是否有亲属同事在我司
friend_name: '', // 朋友姓名
is_insurance: 2, // 是否在京缴过社保
is_out_insurance: 2, // 社保是否转出过外地

is_work_permit: 2, // 是否有北京工作居住证
work_permit_img: '', // 居住证照片
work_permit_no: '', // 居住证编号
work_permit_at: '', // 居住证结束时间
work_permit_url: '/static/img/beijing.png',
work_permit_list: ['/static/img/beijing.png'],

emergency_contact: '', // 紧急联系人
emergency_contact_relation: '', // 与紧急联系人关系
emergency_contact_mobile: '', // 紧急联系人电话
emergency_contact_address: '', // 紧急联系人地址
native_place_id: '', // 籍贯省份ID
native_place_name: '', // 籍贯省份名称
identity_card_positive: [], // 身份证正面URL
identity_card_back: [], // 身份证反面复印件url
passport: [], // 护照地址url

work_city_id: 0,
work_city_name: this.$tsg('北京'), // 工作城市

start_date: '', // 入职日期

areaItems: [],
areaChangeItems: [],
areaChangeItemsEn: [],
/* mobileItems: [{ key: 1, value: '+86 ' }], */
cityItems: [],
provinceItems: [],
minFirstWorkDate: 1979,
delImageFlag: false,

identity_card_positive_url: '',
identity_card_back_url: '',
work_permit_img_url: '',
passport_url: '',


docmHeight: $(window).height(), // 默认屏幕高度

showHeight: $(window).height(), // 实时屏幕高度
hidshow: true,

/* country_mobile_no: '+86 ',
contact_mobile_no: '+86 ', */
hasShowPopup: { data: false },
showLoading: true,
subFlag: '',
delImageItem: { key: '', k: '', field: '' },
code: '',

nativePlaceItems: [],
nativePlaceChangeItems: [],

emergency_contact_mobile_state: false,
mobile_state: false,

ic_expired_date_state: false,
first_work_date_state: false,

surname_pinyin_state: 1,
name_pinyin_state: 1,

areasDataItems: [],

subDisabled: false,
mobileFlag: false,
hidePhysical: true,















isdisabled: true,

defultAddress: {
sheng: '',
shi: '',
qu: ''
},
defultHomeAddress: {
sheng: '',
shi: '',
qu: ''
},
defultCurrentAddress: {
sheng: '',
shi: '',
qu: ''
},
defultEmCONAddress: {
sheng: '',
shi: '',
qu: ''
},
select_address: {
sheng_id: 0,
shi_id: 0,
qu_id: 0
},
select_home_address: {
sheng_id: 0,
shi_id: 0,
qu_id: 0
},
select_current_address: {
sheng_id: 0,
shi_id: 0,
qu_id: 0
},
select_emergency_contact_address: {
sheng_id: 0,
shi_id: 0,
qu_id: 0
}
}
},
computed: {






































































hasFriendItems: function () {
return [
{ key: 1, value: this.$tsg('是') },
{ key: 2, value: this.$tsg('否') }
]
},

insuranceItems: function () {
return [
{ key: 1, value: this.$tsg('是') },
{ key: 2, value: this.$tsg('否') }
]
},

permitItems: function () {
return [
{ key: 1, value: this.$tsg('是') },
{ key: 2, value: this.$tsg('否') }
]
},

effectiveItems: function () {
return [
{ key: 1, value: this.$tsg('否') },
{ key: 2, value: this.$tsg('是') }
]
}


























































},
watch: {
/*
showHeight : {
handler : function(val,oldval) {
var thisHeight = $(this).height();
if (showHeight - thisHeight > 50) {
$('body').css('height', winHeight + 'px');
} else {
$('body').css('height', '100%');
}
},
deep:true
},
*/
marriage: {

handler: function (val, oldval) {
this.changeDegreeItems()
},
deep: true
},
sex: {

handler: function (val, oldval) {
this.changeDegreeItems()
},
deep: true
},
native_place_id: {

handler: function (val, oldval) {
this.getCityItems()
},
deep: true
},
birthday: {

handler: function (val, oldval) {
this.changeFirstWorkDate()
},
deep: true
},
ic_expired_date: {

handler: function (val, oldval) {
this.ic_expired_date = val
if (!this.ic_expired_date || this.ic_expired_date === '0000-00-00' || this.ic_expired_date === '1900-01-01') {
this.ic_expired_date_state = false
} else {
this.ic_expired_date_state = true
}
},
deep: true
},
first_work_date: {

handler: function (val, oldval) {
if (this.isIntern === 0 && (!this.first_work_date || this.first_work_date === '0000-00-00' || this.first_work_date === '1900-01-01')) {
this.first_work_date_state = false
} else {
this.first_work_date_state = true
}
},
deep: true
},
ic_type: {
handler: function (val) {
this.ic_type = val
if (this.ic_type === 1) {
this.country_id = 47206
this.country_name = '中国'
this.isdisabled = true
}
if (this.ic_type === 5) {
if (!this.country_name) {
this.country_id = 47437 
this.country_name = '中国台湾'
}
}

if (!this.isZH) {
this.ic_type = 2
this.country_id = 0
this.country_name = ''
}
}
},
select_address: {
handler: function (val, oldval) {
this.checkResidenceType()
},
deep: true
}
},
mounted () {

window.onresize = () => {
return (() => {

var thisHeight = $(window).height()
if (this.winHeight - thisHeight > 50) {


$('body').css('height', winHeight + 'px')
} else {


$('body').css('height', '100%')
}
})()
}
},
created () {
this.id = this.$route.query.id
this.from = this.$route.query.from

this.mobileFlag = this.isMobile()


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
this.isZH = localStorage.getItem('offer_zh') === 'zh'
this.ic_type = this.isZH ? 1 : 2 
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}


PreEntryApi.checkLogin(
{ id: this.id, code: this.code },

(data, meta) => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

this.showLoading = true

try {

PreEntryApi.getStaffDetail(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.name = data.name ? data.name : data.candidate_name
this.name_pinyin = data.name_pinyin ? data.name_pinyin : ''
this.country_id = data.country_id ? data.country_id : 47206
/* this.country_no = data.code_no ? data.code_no : '' */
this.country_name = data.country_name ? data.country_name : '中国'
this.nation = data.nation ? data.nation : ''
this.sex = data.sex ? data.sex : ''
this.birthday = data.birthday ? data.birthday : ''
this.mobile = data.mobile ? data.mobile : ''

this.ic_type = data.ic_type ? data.ic_type : 1
this.ic_no = data.ic_no ? data.ic_no : ''
this.ic_expired_date = data.ic_expired_date ? data.ic_expired_date : ''
this.certificates_long_effective = data.certificates_long_effective ? data.certificates_long_effective : 1
this.first_work_date = data.first_work_date ? data.first_work_date : ''
this.has_friend = data.has_friend ? data.has_friend : ''
this.friend_name = data.friend_name ? data.friend_name : ''
this.residence_type = data.residence_type ? data.residence_type : ''
this.marriage = data.marriage ? data.marriage : ''
this.is_insurance = data.is_insurance ? data.is_insurance : ''
this.is_work_permit = data.is_work_permit ? data.is_work_permit : ''
this.work_permit_at = data.work_permit_at ? (data.work_permit_at !== '0000-00-00' ? data.work_permit_at : '') : ''
this.work_permit_no = data.work_permit_no ? data.work_permit_no : ''
this.home_address = data.home_address ? data.home_address : ''
this.political_status = data.political_status ? data.political_status : ''
this.current_address = data.current_address ? data.current_address : ''
this.is_out_insurance = data.is_out_insurance ? data.is_out_insurance : ''
this.register_address = data.register_address ? data.register_address : ''
this.work_city_id = data.work_city_id ? data.work_city_id : 0
this.work_city_name = data.work_city_name ? data.work_city_name : ''
this.surname_pinyin = data.surname_pinyin ? data.surname_pinyin : ''
this.surname_zh = data.surname_zh ? data.surname_zh : ''
this.given_name_zh = data.given_name_zh ? data.given_name_zh : ''
this.native_place_id = data.native_place_id ? data.native_place_id : ''
this.native_place_name = data.native_place_name ? data.native_place_name : ''
this.city_id = data.city_id ? data.city_id : ''
this.city_name = data.city_name ? data.city_name : ''
this.start_date = data.start_date ? data.start_date : ''
this.emergency_contact = data.emergency_contact ? data.emergency_contact : ''
this.emergency_contact_mobile = data.emergency_contact_mobile ? data.emergency_contact_mobile : ''
this.emergency_contact_relation = data.emergency_contact_relation ? data.emergency_contact_relation : ''
this.emergency_contact_address = data.emergency_contact_address ? data.emergency_contact_address : ''


this.defultAddress.sheng = data.register_province_name ? data.register_province_name : ''
this.defultAddress.shi = data.register_city_name ? data.register_city_name : ''
this.defultAddress.qu = data.register_county_name ? data.register_county_name : ''

this.defultHomeAddress.sheng = data.home_province_name ? data.home_province_name : ''
this.defultHomeAddress.shi = data.home_city_name ? data.home_city_name : ''
this.defultHomeAddress.qu = data.home_county_name ? data.home_county_name : ''

this.defultCurrentAddress.sheng = data.current_province_name ? data.current_province_name : ''
this.defultCurrentAddress.shi = data.current_city_name ? data.current_city_name : ''
this.defultCurrentAddress.qu = data.current_county_name ? data.current_county_name : ''


this.defultEmCONAddress.sheng = data.emergency_contact_province_name ? data.emergency_contact_province_name : ''
this.defultEmCONAddress.shi = data.emergency_contact_city_name ? data.emergency_contact_city_name : ''
this.defultEmCONAddress.qu = data.emergency_contact_county_name ? data.emergency_contact_county_name : ''

this.select_address.sheng_id = data.register_province_id ? data.register_province_id : 0
this.select_address.shi_id = data.register_city_id ? data.register_city_id : 0
this.select_address.qu_id = data.register_county_id ? data.register_county_id : 0
this.select_home_address.sheng_id = data.home_province_id ? data.home_province_id : 0
this.select_home_address.shi_id = data.home_city_id ? data.home_city_id : 0
this.select_home_address.qu_id = data.home_county_id ? data.home_county_id : 0

this.select_current_address.sheng_id = data.current_province_id ? data.current_province_id : 0
this.select_current_address.shi_id = data.current_city_id ? data.current_city_id : 0
this.select_current_address.qu_id = data.current_county_id ? data.current_county_id : 0
this.select_emergency_contact_address.sheng_id = data.emergency_contact_province_id ? data.emergency_contact_province_id : 0
this.select_emergency_contact_address.shi_id = data.emergency_contact_city_id ? data.emergency_contact_city_id : 0
this.select_emergency_contact_address.qu_id = data.emergency_contact_county_id ? data.emergency_contact_county_id : 0

this.registered_type = data.registered_type ? data.registered_type : 1
this.isIntern = data.is_intern
if (data.is_intern) {

this.first_work_date_state = true
}


this.$refs.setDefultAddress.getCaddress(this.defultAddress, this.select_address)
this.$refs.setDefultHomeAddress.getCaddress(this.defultHomeAddress, this.select_home_address)
this.$refs.setDefultCurrentAddress.getCaddress(this.defultCurrentAddress, this.select_current_address)
this.$refs.setDefultContactAddress.getCaddress(this.defultEmCONAddress, this.select_emergency_contact_address)

if (this.country_id === 0 || this.country_id === undefined) {
this.country_id = 47206
}
if (this.country_id === 47206) {
if (this.nation === '国外户籍') {
this.nation = ''
}
} /* else {
this.mobileItems.push({
key: 2,
value: '+' + data.code_no + ' ',
})
} */

if (!this.birthday || this.birthday === '0000-00-00') {
this.birthday = ''
this.birthday_state = false
} else {
this.birthday_state = true
}

if (!this.ic_expired_date || this.ic_expired_date === '0000-00-00' || this.ic_expired_date === '1900-01-01') {
this.ic_expired_date = ''
this.ic_expired_date_state = false
} else {
this.ic_expired_date_state = true
}

if (!this.first_work_date || this.first_work_date === '0000-00-00' || this.first_work_date === '1900-01-01') {
this.first_work_date = ''
this.first_work_date_state = false
} else {
this.first_work_date_state = true
}

var reg = /^[A-Za-z]+$/
if (reg.test(this.surname_pinyin)) {
this.surname_pinyin_state = 3
}

if (reg.test(this.name_pinyin)) {
this.name_pinyin_state = 3
}

this.city_id && this.getCityItems()


this.mobileState()
this.emergencyContactState()

this.changeDegreeItems()
this.changeFirstWorkDate()

/**
* 1、获取预入职员工的类型【1：白领 2:蓝领 3:销售管理 4:店端】
* 2、获取预入职员工的部门id
* 3、如果是蓝领、并且是制造与质量-常州基地129、制造与质量-PACK厂103 的员工；学历附件非必填
*/

var jobType = data.job_type



PreEntryApi.getAreaByName(
{ levelType: 'country' },

(data, meta) => {
if (data) {
this.areaItems = data[0]

var areaChangeItems = []
var areaChangeItemsEn = []
this.areaItems.forEach(function (item) {
areaChangeItems.push({
title: item.name,
other: item.id
/*
country_no: item.code_no,
*/
})
areaChangeItemsEn.push({
title: item.en_name,
other: item.id
/*
country_no: item.code_no,
*/
})
})

this.areaChangeItems = areaChangeItems
this.areaChangeItemsEn = areaChangeItemsEn
}
}
)


PreEntryApi.getAreaByName(
{ levelType: 'province' },

(data, meta) => {
if (data) {
this.areasDataItems = data
}
}
)
}
},

err => {
if (err === -2) {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
this.$message.error(this.$tsg('基本信息数据获取失败。'))
this.showLoading = false
}





)

PreEntryApi.getMaterial(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.identity_card_positive = data.identity_card_positive
this.identity_card_back = data.identity_card_back
this.work_permit_img = data.work_permit_img
this.passport = data.passport

if (data.work_permit_img && data.work_permit_img.length > 0) {
this.work_permit_img_url = data.work_permit_img[0].src
console.log(this.work_permit_img_url)
}
if (data.identity_card_positive && data.identity_card_positive.length > 0) {
this.identity_card_positive_url = data.identity_card_positive[0].src
}
if (data.identity_card_back && data.identity_card_back.length > 0) {
this.identity_card_back_url = data.identity_card_back[0].src
}
if (data.passport && data.passport.length > 0) {
this.passport_url = data.passport[0].src
}
}
this.showLoading = false
},

err => {
this.$message.error(this.$tsg('证件照片获取失败。'))
this.showLoading = false
},

err => {
this.$message.error(this.$tsg('系统内部错误，请联系管理员。'))
this.showLoading = false
}
)


PreEntryApi.getArea({ id: 0 }, (data, meta) => {
var res = []

if (data) {
data.forEach(function (item) {
res.push({
en_title: item.en_name,
title: item.name,
other: item.id
/*
country_no: item.code_no,
*/
})
})
}
this.areaItems = res
})


PreEntryApi.getArea({ id: 47206 }, (data, meta) => {
var res = []
if (data) {
data.forEach(function (item) {
res.push({
title: item.name,
other: item.id,
en_title: item.en_name
/*
country_no: item.code_no,
*/
})
})
}
this.nativePlaceItems = res
this.nativePlaceChangeItems = res
})
} catch (e) {
this.$message.error(this.$tsg('系统内部错误，请联系管理员。'))
this.showLoading = false
}

this.postPsOption()
},
methods: {
onEmergencyContactInput (e) {
const v = String(e.target.value || '')
const cleaned = v.replace(/[0-9]/g, '')
if (v !== cleaned) {
e.target.value = cleaned             
}
if (cleaned !== this.emergency_contact) {
this.emergency_contact = cleaned     
}
},
onEmergencyMobileInput (e) {
const v = String(e.target.value || '')
const cleaned = v.replace(/\D+/g, '')  
if (v !== cleaned) {
e.target.value = cleaned            
}
if (cleaned !== this.emergency_contact_mobile) {
this.emergency_contact_mobile = cleaned
}
},
onMobileInput (e) {
const v = String(e.target.value || '')
const cleaned = v.replace(/\D+/g, '')
if (v !== cleaned) e.target.value = cleaned
if (cleaned !== this.mobile) this.mobile = cleaned
},
clear (type, key, val) {
if (val) {
this[type][key][val] = ''
} else {
this[type] = ''
}
},
isMobile () {
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
return true
}
return false
},
changeSurNamePinyin () {
var reg = /^[A-Za-z]+$/
this.surname_pinyin_state = reg.test(this.surname_pinyin) ? 3 : 1
},
changeNamePinyin () {
var reg = /^[A-Za-z]+$/
this.name_pinyin_state = reg.test(this.name_pinyin) ? 3 : 1
},
getNationResult (val) {












},
resultNationClick (item) {
this.nation = item.title
},
getCityResult (val) {
if (this.cityItems.length === 0) {
return
}
const selectedCity = this.cityItems.find(
item => String(item.other) === String(this.city_id)
)
if (!selectedCity || selectedCity.title !== val) {
this.city_id = ''
}








































},
resultNativeClick (item) {
this.native_place_name = item.title
this.native_place_id = item.other
this.city_name = ''
this.city_id = ''
if (!this.native_place_id) {
this.native_place_id = 999993
}
},
getNativeResult (val) {
if (this.nativePlaceItems.length === 0) {
return
}
const selectedProvince = this.nativePlaceItems.find(
item => String(item.other) === String(this.native_place_id)
)
if (!selectedProvince || selectedProvince.title !== val) {
this.native_place_id = ''
this.city_id = ''
this.city_name = ''
this.cityItems = []
}

















},
resultCountryCancel () {
this.country_id = 0
this.country_name = ''
},
resultCountryClick (item) {
if (Number(item.other) !== 47206 && Number(this.ic_type) === 1) {



this.city_name = ''
this.city_id = ''
this.native_place_id = ''
this.native_place_name = ''
}

if (Number(item.other) === 47206 && this.nation === '国外户籍') {
this.nation = ''
}
this.country_name = item.title
/*
this.country_no = item.country_no
*/
this.country_id = item.other
/* this.mobileItems.push({
key: 2,
value: '+' + item.country_no + ' ',
}) */
if (!this.country_id) {
this.country_id = 0
}





if (Number(this.ic_type) === 4 && (Number(item.other) !== 47439 && Number(item.other) !== 47438)) {
this.country_id = 0
this.country_name = ''
this.$message.error(this.$tsg('请选择证件类型对应的中国香港/中国澳门'))
return false
}
if (Number(this.ic_type) === 5 && (Number(item.other) !== 47437)) {
this.country_id = 0
this.country_name = ''
this.$message.error(this.$tsg('请选择证件类型对应的中国台湾'))
return false
}
if (Number(this.ic_type) === 1 && Number(item.other) !== 47206) {
this.country_id = 0
this.country_name = ''
this.$message.error(this.$tsg('请选择证件类型对应的中国'))
return false
}
if (Number(this.ic_type) === 1 && Number(item.other) !== 47206) {
this.country_id = 0
this.country_name = ''
this.$message.error(this.$tsg('请选择证件类型对应的中国'))
return false
}
if (Number(this.ic_type) === 2 && (Number(item.other) === 47206 || Number(item.other) === 47437 || Number(item.other) === 47439 || Number(item.other) === 47438)) {
this.country_id = 0
this.country_name = ''
this.$message.error(this.$tsg('请选择身份证件对应的国家/地区'))
return false
}




























if (item.other !== '47206' && (item.other !== '' || item.other !== undefined)) {
this.isdisabled = false
}
if (item.other === '47206') {
this.isdisabled = false
}
},
abroadCountryClick () {
this.country_id = 0
},

getCountryResult (val) {
val = val.replace(/^\s*|\s*$/g, '')
var areaChangeItems = []
var areaChangeItemsEn = []
if (this.areaItems && !val) {
this.areaItems.forEach(function (item) {
areaChangeItems.push({
title: item.name,
other: item.id
/*
country_no: item.code_no,
*/
})
areaChangeItemsEn.push({
title: item.en_name,
other: item.id
/*
country_no: item.code_no,
*/
})
})

this.areaChangeItems = areaChangeItems
this.areaChangeItemsEn = areaChangeItemsEn
console.log(val)
return false
}

var res = [],
isComprise = false
this.areaChangeItems.forEach(function (item) {
if (item.title !== null && item.title.indexOf(val) !== -1) {
isComprise = true
res.push({
title: item.title,
other: item.other
/*
country_no: item.code_no,
*/
})
}
})

if (val && !isComprise) {
res.unshift({ title: val, other: -1 })
}

this.areaChangeItems = res
},
resultCityClick (item) {
this.city_name = item.title
this.city_id = item.other
if (!this.city_id) {
this.city_id = 999991
}
},
getCityItems () {
if (this.native_place_id) {

PreEntryApi.getArea({ id: this.native_place_id }, (data, meta) => {
let res = []
if (data) {
data.forEach(function (item) {
res.push({
title: item.name,
other: item.id,
en_title: item.en_name
/*
country_no: item.code_no,
*/
})
})
}

this.cityItems = res
console.log(this.cityItems)
})
}
},
emailState () {

if (!Validate.isEmail(this.email)) {
this.email_state = false
} else {
this.email_state = true
}
},
mobileState () {
if (!Validate.isMobile(this.mobile)) {
this.mobile_state = false
} else {
this.mobile_state = true
}
},
emergencyContactState () {
if (!Validate.isMobile(this.emergency_contact_mobile)) {
this.emergency_contact_mobile_state = false
} else {
this.emergency_contact_mobile_state = true
}
},
uploadCard (field) {
this.$refs[field].UploadFileType()
},
delImage (key, field) {
this.delImageItem.key = key
this.delImageItem.field = field
this.delImageFlag = true
},

sendDelImage () {
var field = this.delImageItem.field,
key = this.delImageItem.key

this.delImageItem = { key: '', field: '' }
this[field].splice(key, 1)

try {
PreEntryApi.updateMaterialByField(
{
id: this.id,
fieldName: field,
field: this[field]
},

(data, meta) => {
this.delImageFlag = false
},

err => {
this.$message.error(this.$tsg('图片删除失败。'))
},

err => {
this.$message.error(this.$tsg('系统内部错误，请联系管理员。'))
}
)
} catch (e) {
this.$message.error(this.$tsg('系统内部错误，请联系管理员。'))
}
},
changeFirstWorkDate () {
if (this.birthday) {
var birthdayArr = this.birthday.split('-')
if (birthdayArr[0]) {
this.minFirstWorkDate = parseInt(birthdayArr[0]) + 16

}
}
},

changeDegreeItems () {
if (this.marriage === 1) {






if (!this.emergency_contact) {
this.emergency_contact_relation = ''
this.emergency_contact = ''
this.emergency_contact_mobile = ''
this.emergency_contact_address = ''
}
}
if (this.marriage === 2) {
if (this.sex === 1) {







if (!this.emergency_contact) {
this.emergency_contact_relation = ''
this.emergency_contact = ''
this.emergency_contact_mobile = ''
this.emergency_contact_address = ''
}
} else {







if (!this.emergency_contact) {
this.emergency_contact_relation = ''
this.emergency_contact = ''
this.emergency_contact_mobile = ''
this.emergency_contact_address = ''
}
}
}
if (this.marriage === 3) {
if (this.sex === 1) {






if (!this.emergency_contact) {
this.emergency_contact_relation = ''
this.emergency_contact = ''
this.emergency_contact_mobile = ''
this.emergency_contact_address = ''
}
} else {






if (!this.emergency_contact) {
this.emergency_contact_relation = ''
this.emergency_contact = ''
this.emergency_contact_mobile = ''
this.emergency_contact_address = ''
}
}
}
if (this.marriage === 4 || this.marriage === 5) {






if (!this.emergency_contact) {
this.emergency_contact_relation = ''
this.emergency_contact = ''
this.emergency_contact_mobile = ''
this.emergency_contact_address = ''
}
}
},
showStep () {
this.hasShowPopup.data = !this.hasShowPopup.data
},


returnFileData (res, field) {
this[field] = [res]

if (
field === 'identity_card_positive' &&
res.data.identity_card_positive &&
res.data.identity_card_positive['image_status'] === 'normal'
) {
this.country_id = 47206 
this.isdisabled = true 
var cardMsg = res.data.identity_card_positive['words_result']

this.ic_no = cardMsg['公民身份号码']['words']


var birthday = cardMsg['出生']['words'],
birthdayArray = []
birthdayArray.push(birthday.slice(0, 4))
birthdayArray.push(birthday.slice(4, 6))
birthdayArray.push(birthday.slice(6, 8))
this.birthday = birthdayArray.join('-')


this.name = cardMsg['姓名']['words']

this.surname_pinyin = res.data.surname_pinyin
this.given_name_zh = res.data.given_name_zh
this.surname_zh = res.data.surname_zh

this.name_pinyin = res.data.name_pinyin


this.sex = cardMsg['性别']['words'] === '男' ? 1 : 2


var family = cardMsg['民族']['words']
this.nationItems.forEach(
function (item) {
if (item.title === family) {
this.nation = family
}
if (item.title === family + '族') {
this.nation = family + '族'
}
}.bind(this)
)


var address = cardMsg['住址']['words']




this.nativePlaceItems.forEach(
function (item) {
if (address.indexOf(item.title) !== -1) {
this.native_place_id = item.other
this.native_place_name = item.title
this.defultAddress.sheng = item.title
this.defultAddress.shi = ''
this.defultAddress.qu = ''
this.$refs.setDefultAddress.getCaddress(this.defultAddress, this.select_address)
if (!this.native_place_id) {
this.native_place_id = 999993
}
}
}.bind(this)
)

if (this.native_place_id) {

PreEntryApi.getArea({ id: this.native_place_id }, (data, meta) => {
let res = []
if (data) {
data.forEach(function (item) {
res.push({
title: item.name,
other: item.id,
en_title: item.en_name
/*
country_no: item.code_no,
*/
})
})
}
this.cityItems = res

this.cityItems.forEach(
function (item) {
if (address.indexOf(item.title) !== -1) {
this.city_id = item.other
this.city_name = item.title
this.defultAddress.shi = item.title
this.$refs.setDefultAddress.getCaddress(this.defultAddress, this.select_address)
if (!this.city_id) {
this.city_id = 999991
}
}
}.bind(this)
)
})
}
}
if (
field === 'identity_card_back' &&
res.data.identity_card_back &&
res.data.identity_card_back.image_status === 'normal'
) {
var cardBack = res.data.identity_card_back['words_result']


var icDate = cardBack['失效日期']['words'],
icDateArray = []
if (icDate === '长期') {
icDateArray = ['9999', '12', '31']
this.certificates_long_effective = 2
} else {
icDateArray.push(icDate.slice(0, 4))
icDateArray.push(icDate.slice(4, 6))
icDateArray.push(icDate.slice(6, 8))
this.certificates_long_effective = 1
}
this.ic_expired_date = icDateArray.join('-')
}

this[field + '_url'] = res.src
},


blurSubmit (value, $event) {

var field = $event.target.name
if (!this.id) {
this.$message.error(this.$tsg('非法操作。'))
return false
}

this.subMaterial()
},
changeEffectiv () {
if (parseInt(this.certificates_long_effective) === 2) {
this.ic_expired_date = '9999-12-31'
}
},


sendMaterial (returnFlag) {
if (this.ic_type === 5) {
if (this.ic_no.length !== 8) {
this.$message.error(this.$tsg('证件信息有误（不满足8位字符）'))
return false
}
}
if (this.country_id === 47437 && this.ic_type !== 5) {
this.country_id = ''
this.country_name = ''
this.$message.error(this.$tsg('证件类型仅可选择台湾居民来往大陆通行证'))
return false
}
if (this.ic_type !== 4 && (this.country_id === 47439 || this.country_id === 47438)) {
this.country_id = ''
this.country_name = ''
this.$message.error(this.$tsg('证件类型仅可选择港澳居民来往内地通行证'))
return false
}
if (this.ic_type === 4) {
if (this.ic_no.length !== 9) {
this.$message.error(this.$tsg('证件信息有误（不满足9位字符）'))
return false
}
}
if (this.ic_type === 1 && this.name !== (this.surname_zh + this.given_name_zh)) {
this.$message.error(this.$tsg('证件姓名(中文)与姓/名不对应'))
return false
}
if (this.country_id === 47206 && this.ic_type !== 1) {
this.$message.error(this.$tsg('中国国籍认证类型请选择【身份证】'))
return false
}

if (this.country_id && this.country_id !== 47206 && this.ic_type === 1) {
this.$message.error(this.$tsg('非中国大陆认证类型请选择非【身份证】'))
return false
}

if (!this.id) {
this.$message.error(this.$tsg('非法操作。'))
return false
}

var isNationRight = false

this.nationItems.forEach(
function (item) {
if (this.nation === item.title) {
isNationRight = true
}
}.bind(this)
)
if (this.nation === '') {
isNationRight = true
}

if (this.country_id === 47206 && isNationRight === false) {
alert('请选择正确的民族信息~')
return false
}
if (!this.emergency_contact_mobile_state) {
alert('紧急联系人手机格式错误~')
return false
}
this.subFlag = returnFlag
this.subMaterial()
},
getDateYearSub (startDateStr, endDateStr) {
if (!startDateStr || !endDateStr) return false
const [sy, sm, sd] = startDateStr.split('-').map(n => parseInt(n, 10))
const [ey, em, ed] = endDateStr.split('-').map(n => parseInt(n, 10))

const start = new Date(sy, sm - 1, sd)
const end = new Date(ey, em - 1, ed)


const plus16 = new Date(sy + 16, sm - 1, sd)




return end.getTime() >= plus16.getTime()
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
changeIcType () {
if (this.ic_type === 1) {  // 身份证
this.isdisabled = true
this.residence_type = 1  
this.registered_type = 1 
this.country_id = 47206 
this.country_name = '中国'
}

if (this.ic_type === 2) {
this.isdisabled = false
this.residence_type = 5  
this.registered_type = 3 
if (this.country_id === 47206 || this.country_id === 47437 || this.country_id === 47438 || this.country_id === 47439) {
this.country_id = 0
this.country_name = ''
}

}

if (this.ic_type === 4) {
this.isdisabled = false
this.residence_type = 5  
this.registered_type = 3 

if (this.country_id !== 47438 && this.country_id !== 47439) {
this.country_id = '' 
this.country_name = ''
}
}

if (this.ic_type === 5) {
this.isdisabled = false
this.residence_type = 5  
this.registered_type = 3 

this.country_id = 47437 
this.country_name = '中国台湾'
}

this.checkResidenceType()
},

changeResidenceType () {












this.checkResidenceType()
},
checkResidenceType () {
if (this.country_id === 47206 && this.ic_type === 1) {
if (this.registered_type === 3) {
this.registered_type = 1
this.residence_type = 1
}
if (this.registered_type === 1) {
if (this.work_city_id === this.select_address.shi_id) {
this.residence_type = 1
}
if (this.work_city_id !== this.select_address.shi_id && this.select_address.shi_id) {
this.residence_type = 3
}
}
if (this.registered_type === 2) {
if (this.work_city_id === this.select_address.shi_id) {
this.residence_type = 2
}
if (this.work_city_id !== this.select_address.shi_id && this.select_address.shi_id) {
this.residence_type = 4
}
}
} else {
this.registered_type = 3 
this.residence_type = 5  
}
},

getAreaId (val) {
this.select_address = val
},
getHomeAreaId (val) {
this.select_home_address = val
},
getCurrentAreaId (val) {
this.select_current_address = val
},
getContactAreaId (val) {
this.select_emergency_contact_address = val
},
getIsSubArea (id) {
console.log('当前传入的上级ID：', id)


if (!this.areasDataItems || Object.keys(this.areasDataItems).length === 0) {
console.warn('地区数据未加载完成')
return []
}



const subAreas = this.areasDataItems[id] || []


const result = subAreas.map(item => ({
title: item.name || item.en_name || '',
other: item.id || ''
})).filter(item => item.title && item.other) // 过滤空数据

console.log('筛选后的下级地区：', result)
return result
},

validateForm () {
if (this.surname_zh === '') {
this.$message.error(this.$tsg('姓必填'))
return false
}
if (this.given_name_zh === '') {
this.$message.error(this.$tsg('名必填'))
return false
}
if (this.ic_type === 1 && this.name !== (this.surname_zh + this.given_name_zh)) {
this.$message.error(this.$tsg('证件姓名(中文)与姓/名不对应'))
return false
}
const needCity = (shengId) => {
const cities = this.getIsSubArea(shengId) || []
return Array.isArray(cities) && cities.length > 0
}
const needDistrict = (shiId) => {
const districts = this.getIsSubArea(shiId) || []
return Array.isArray(districts) && districts.length > 0
}

if (this.ic_type === 1) {
if (!this.select_address.sheng_id) {
this.$message.error(this.$tsg('户籍所在地（省）请填写完整'))
return false
}
if (needCity(this.select_address.sheng_id) && !this.select_address.shi_id) {
this.$message.error(this.$tsg('户籍所在地（市）请填写完整'))
return false
}
if (needCity(this.select_address.shi_id) && !this.select_address.qu_id) {
this.$message.error(this.$tsg('户籍所在地（区）请填写完整'))
return false
}
if (this.register_address === '') {
this.$message.warning(this.$tsg('户籍详细地址请填写完整'))
return false
}
}

if (!this.select_home_address || !this.select_home_address.sheng_id) {
this.$message.error(this.$tsg('通讯地址（省）请填写完整'))
return false
}
if (needCity(this.select_home_address.sheng_id) && !this.select_home_address.shi_id) {
this.$message.error(this.$tsg('通讯地址（市）请填写完整'))
return false
}
if (
this.select_home_address.shi_id &&
needDistrict(this.select_home_address.shi_id) &&
!this.select_home_address.qu_id
) {
this.$message.error(this.$tsg('通讯地址（区）请填写完整'))
return false
}
if (!this.home_address || this.home_address.trim() === '') {
this.$message.error(this.$tsg('通讯地址详细地址填写完整'))
return false
}


if (!this.select_current_address || !this.select_current_address.sheng_id) {
this.$message.error(this.$tsg('现居住地（省）请填写完整'))
return false
}
if (needCity(this.select_current_address.sheng_id) && !this.select_current_address.shi_id) {
this.$message.error(this.$tsg('现居住地（市）请填写完整'))
return false
}
console.log('现居地')
console.log('------' + this.select_current_address.shi_id)
console.log('------' + needDistrict(this.select_current_address.shi_id))
console.log('------' + this.select_current_address.qu_id)
if (
this.select_current_address.shi_id &&
needDistrict(this.select_current_address.shi_id) &&
!this.select_current_address.qu_id
) {
this.$message.error(this.$tsg('现居住地（区）请填写完整'))
return false
}
if (!this.current_address || this.current_address.trim() === '') {
this.$message.error(this.$tsg('现居住地详细地址请填写完整'))
return false
}


if (!this.select_emergency_contact_address || !this.select_emergency_contact_address.sheng_id) {
this.$message.error(this.$tsg('紧急联系人地址（省）请填写完整'))
return false
}
if (needCity(this.select_emergency_contact_address.sheng_id) && !this.select_emergency_contact_address.shi_id) {
this.$message.error(this.$tsg('紧急联系人地址（市）请填写完整'))
return false
}
if (
this.select_emergency_contact_address.shi_id &&
needDistrict(this.select_emergency_contact_address.shi_id) &&
!this.select_emergency_contact_address.qu_id
) {
this.$message.error(this.$tsg('紧急联系人地址（区）请填写完整'))
return false
}
if (!this.emergency_contact_address || this.emergency_contact_address.trim() === '') {
this.$message.error(this.$tsg('紧急联系人地址详细地址请填写完整'))
return false
}

if (this.country_id === 47206 && this.ic_type !== 1) {
this.$message.error(this.$tsg('中国国籍认证类型请选择【身份证】'))
return false
}

if (this.birthday && this.start_date && this.birthday !== '0000-00-00') {
if (!this.getDateYearSub(this.birthday, this.start_date)) {
this.$message.error(this.$tsg('您未满16周岁，不能提交预入职信息。'))
return false
}
}
if (this.birthday && this.first_work_date && this.birthday !== '0000-00-00') {
if (!this.getDateYearSub(this.birthday, this.first_work_date)) {
this.$message.error(this.$tsg('请准确填写您毕业后首次正式参加工作的时间，如无其他正式工作经历，填写您的入职日期即可。'))
return false
}
}
if (this.first_work_date && this.start_date && this.first_work_date > this.start_date && this.isIntern === 0) {
this.$message.error(this.$tsg('首次工作时间不能大于入职日期（' + this.start_date) + ')')
return false
}

if (this.work_city_id === 32) {
if (!this.is_insurance && this.isZh) {
this.$message.warning(this.$tsg('请选择是否在北京缴纳过社保。'))
return false
}
if (!this.is_work_permit && this.isZh) {
this.$message.warning(this.$tsg('请选择是否有北京工作居住证。'))
return false
}
if (this.is_work_permit === 1) {
if (this.work_permit_img === '' || this.work_permit_no === '' || this.work_permit_at === '') {
this.$message.warning(this.$tsg('您选择了工作居住证，请您先补全工作居住证相关'))
return false
}
}
}

return true
},

subMaterial () {
if (this.certificates_long_effective === 2) {
this.ic_expired_date = '9999-12-31'
} else {
if (!this.ic_expired_date) {
this.$message.error(this.$tsg('请选择证件有效期'))
return false
}
}
this.surname_zh = this.surname_zh.toUpperCase()
this.given_name_zh = this.given_name_zh.toUpperCase()

console.log(this.validateForm())
if (!this.validateForm()) {
this.subDisabled = false
return false
}

if (this.ic_type !== 1) {
this.nation = ''
}
if (this.ic_type === 2) {
this.political_status = ''
}

this.nativePlaceItems.forEach(
function (item) {
if (item.title === this.native_place_name) {
this.native_place_id = item.other
}
}.bind(this)
)



this.cityItems.forEach(
function (item) {
if (String(item.other) === String(this.city_id)) {
this.city_name = item.title
}
}.bind(this)
)



if (this.ic_type === 1) {
this.register_province_id = this.select_address.sheng_id 
this.register_province_name = this.defultAddress.sheng  
this.register_city_id = this.select_address.shi_id
this.register_city_name = this.defultAddress.shi
this.register_county_id = this.select_address.qu_id 
this.register_county_name = this.defultAddress.qu 
} else {
this.register_province_id = 0 
this.register_province_name = ''  
this.register_city_id = 0
this.register_city_name = ''
this.register_county_id = 0 
this.register_county_name = '' 
this.register_address = '' 
this.native_place_name = ''
this.native_place_id = ''
this.city_name = '' 
this.city_id = ''
}
this.home_province_id = this.select_home_address.sheng_id 
this.home_province_name = this.defultHomeAddress.sheng  
this.home_city_id = this.select_home_address.shi_id
this.home_city_name = this.defultHomeAddress.shi
this.home_county_id = this.select_home_address.qu_id 
this.home_county_name = this.defultHomeAddress.qu 

this.current_province_id = this.select_current_address.sheng_id 
this.current_province_name = this.defultCurrentAddress.sheng  
this.current_city_id = this.select_current_address.shi_id
this.current_city_name = this.defultCurrentAddress.shi
this.current_county_id = this.select_current_address.qu_id 
this.current_county_name = this.defultCurrentAddress.qu 
this.emergency_contact_province_id = this.select_emergency_contact_address.sheng_id 
this.emergency_contact_province_name = this.defultEmCONAddress.sheng  
this.emergency_contact_city_id = this.select_emergency_contact_address.shi_id
this.emergency_contact_city_name = this.defultEmCONAddress.shi
this.emergency_contact_county_id = this.select_emergency_contact_address.qu_id 
this.emergency_contact_county_name = this.defultEmCONAddress.qu 
PreEntryApi.sendMaterial(
{
id: this.id,
code: this.code,
name: this.name,
name_pinyin: this.name_pinyin,
given_name_zh: this.given_name_zh,
surname_pinyin: this.surname_pinyin,
surname_zh: this.surname_zh,
country_id: this.country_id,
country_name: this.country_name,
family: this.family,
nation: this.nation,
sex: this.sex,
birthday: this.birthday,
mobile: this.mobile,

ic_type: this.ic_type,
ic_no: this.ic_no,
ic_expired_date: this.ic_expired_date,
certificates_long_effective: this.certificates_long_effective,
first_work_date: this.first_work_date,
has_friend: this.has_friend,
friend_name: this.friend_name,
residence_type: this.residence_type,
registered_type: this.registered_type, // 户口类型
marriage: this.marriage,
is_insurance: this.is_insurance,
is_work_permit: this.is_work_permit, // 是否有北京工作居住证
work_permit_img: this.work_permit_img, // 北京工作居住证照片
work_permit_at: this.work_permit_at, // 北京工作居住证截至时间
work_permit_no: this.work_permit_no, // 北京工作居住证编号
home_address: this.home_address,
positive_status: this.positive_status,
back_status: this.back_status,
passport_status: this.passport_status,
political_status: this.political_status,
current_address: this.current_address,
is_out_insurance: this.is_out_insurance,
register_province_id: this.register_province_id,
register_province_name: this.register_province_name,
register_city_id: this.register_city_id,
register_city_name: this.register_city_name,
register_county_id: this.register_county_id,
register_county_name: this.register_county_name,
register_address: this.register_address,
home_province_id: this.home_province_id,
home_province_name: this.home_province_name,
home_city_id: this.home_city_id,
home_city_name: this.home_city_name,
home_county_id: this.home_county_id,
home_county_name: this.home_county_name,
current_province_id: this.current_province_id,
current_province_name: this.current_province_name,
current_city_id: this.current_city_id,
current_city_name: this.current_city_name,
current_county_id: this.current_county_id,
current_county_name: this.current_county_name,
emergency_contact_province_id: this.emergency_contact_province_id,
emergency_contact_province_name: this.emergency_contact_province_name,
emergency_contact_city_id: this.emergency_contact_city_id,
emergency_contact_city_name: this.emergency_contact_city_name,
emergency_contact_county_id: this.emergency_contact_county_id,
emergency_contact_county_name: this.emergency_contact_county_name,
native_place_id: this.native_place_id,
native_place_name: this.native_place_name,
city_id: this.city_id,
city_name: this.city_name,
emergency_contact: this.emergency_contact,
emergency_contact_mobile: this.emergency_contact_mobile,
emergency_contact_relation: this.emergency_contact_relation,
emergency_contact_address: this.emergency_contact_address
},

(data, meta) => {
if (data !== '') {
this.$message.error(this.$tsg('基本信息更新失败。'))
this.subDisabled = false
return false
}

this.subDisabled = false
if (this.subFlag) {
if (this.subFlag === 2) {
this.$router.push({ name: 'onboard.edu', query: { id: this.id } })
} else {
this.$router.push({
name: 'onboard.list',
query: { id: this.id }
})
}
}
},

err => {
this.subDisabled = false
}
)
},
historyBack () {
if (this.from === 'thanks') {

this.$router.push({ name: 'onboard.thanks', query: { id: this.id }})
} else {
history.go(-1)
}
},
postPsOption () {
PreEntryApi.postPsOption(
{},
(data, meta) => {

const icTypeObj = data['1'] || {}
this.icTypeItems = Object.keys(icTypeObj).map(key => ({
key: Number(key),
value: icTypeObj[key]
}))

const sexObj = data['2'] || {}
this.sexItems = Object.keys(sexObj).map(key => ({
key: Number(key),
value: sexObj[key]
}))

const residenceTypeObj = data['3'] || {}
this.residenceTypeItems = Object.keys(residenceTypeObj).map(key => ({
key: Number(key),
value: residenceTypeObj[key]
}))


const registeredTypeObj = data['4'] || {}
this.registeredTypeCNItems = Object.keys(registeredTypeObj)
.filter(key => Number(key) === 1 || Number(key) === 2)
.map(key => ({
key: Number(key),
value: registeredTypeObj[key]
}))

const registeredTypeObj2 = data['4'] || {}
this.registeredTypeFNItems = Object.keys(registeredTypeObj2)
.filter(key => Number(key) === 3)
.map(key => ({
key: Number(key),
value: registeredTypeObj2[key]
}))

const marriageObj = data['5'] || {}
this.marriageItems = Object.keys(marriageObj).map(key => ({
key: Number(key),
value: marriageObj[key]
}))

const politicalObj = data['6'] || {}
this.politicalOutlookItems = Object.keys(politicalObj).map(key => ({
key: Number(key),
value: politicalObj[key]
}))

const degreeTypeObj = data['8'] || {}
this.degreeTypeItems = Object.keys(degreeTypeObj).map(key => ({
key: Number(key),
value: degreeTypeObj[key]
}))

const emergencyObj = data['12'] || {}
this.emergencyItems = Object.keys(emergencyObj).map(key => ({
key: key,
value: emergencyObj[key]
}))

const nationObj = data['13'] || {}
this.nationItems = Object.keys(nationObj).map(key => ({
title: nationObj[key],
other: nationObj[key]
}))
this.nationChangeItems = this.nationItems

this.showLoading = false
},
err => {
this.$message.error(this.$tsg('选项数据获取失败。'))
this.showLoading = false
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/material.vue